<template>
  <div>
    <slot></slot>
    <div v-show="visible" class="loading">
      <v-progress-circular v-show="!error" class="loading-icon" indeterminate v-bind:size="50"></v-progress-circular>
      <div class="content"><slot name="infoContent"></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["visible", "error"]
}
</script>

<style scoped>
.loading {
  position: fixed;
  background: rgba(0, 0, 0, 0.3);
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 9999;
}
.loading .loading-icon {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateY(-50%) translateX(-50%);
  -ms-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
}
.loading .content {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translateY(-50%) translateX(-50%);
  -ms-transform: translateY(-50%) translateX(-50%);
  transform: translateY(-50%) translateX(-50%);
}
</style>
